import TrackingHelperInstance from './gtmTrackingHelper';

class GtmProductImpressionViewRichRelevanceDelegator {
	constructor() {
		this.type = 'richRelevance_Loaded';
		this.dataMapper = [
			{
				defaultValue: TrackingHelperInstance.generateActionFieldString(),
				gtmKey: 'list',
			},
			{ dataName: 'data-product-title', gtmKey: 'name' },
			{ dataName: 'data-legacy-sku', gtmKey: 'id' },
			{ dataName: 'data-price-excl', gtmKey: 'price' },
			{ dataName: 'data-sku-category-name', gtmKey: 'category' },
			{ dataName: 'data-sku-item-category', gtmKey: 'item_category' },
			{ dataName: 'data-sku-item-category2', gtmKey: 'item_category2' },
			{ dataName: 'data-sku-item-category3', gtmKey: 'item_category3' },
			{ dataName: 'data-stock-status-ga', gtmKey: 'dimension27' },
			{ defaultValue: 1, gtmKey: 'position' },
		];
	}

	getTrackingData(target, data) {
		if (!data.element) return;

		const selector = '[data-gtm-tracking-type="gtm_rr_product_view"]';
		const productArray = this.findRRProducts(selector, data.element);
		const mappedRRProducts = this.mapRRProducts(productArray);

		if (mappedRRProducts.length) {
			return {
				event: 'productView',
				ecommerce: {
					impressions: mappedRRProducts,
				},
			};
		}
	}

	findRRProducts(selector, parentElement) {
		return Array.from(parentElement.querySelectorAll(selector));
	}

	mapRRProducts(productArray) {
		return productArray.map(product =>
			TrackingHelperInstance.getRequiredDataAsObject(product, this.dataMapper),
		);
	}
}

const GtmProductImpressionViewRichRelevanceDelegatorInstance =
	new GtmProductImpressionViewRichRelevanceDelegator();
export default GtmProductImpressionViewRichRelevanceDelegatorInstance;

// for test purpose only
export const GtmProductImpressionViewRichRelevanceDelegatorClass =
	GtmProductImpressionViewRichRelevanceDelegator;
